<div class="flex min-h-20 flex-wrap items-center justify-end py-[25px] pl-[15px] pt-[20px]">
  <div class="mr-auto text-2xl max-mobile-small:order-1">
    <h1 class="block text-[26px]">Explore SmartDeFi&trade; tokens</h1>
  </div>
  <div class="flex w-[217px] max-mobile-small:order-3 max-mobile-small:mx-auto max-mobile-small:mt-2"></div>
  <div class="ml-12 flex items-center text-xl text-grey-light max-mobile-small:order-2 max-mobile-small:ml-auto"></div>
</div>
<section class="c-table c-table--tokens h-full pb-[10px]" scrollbarDirective>
  <div class="flex h-full min-w-[1000px] flex-col">
    <div
      class="c-table-row--tokens relative mb-[5px] grid cursor-default justify-between bg-background-white px-[10px] py-[10px] pl-0 font-medium text-dirty-white"
    >
      <div class="flex-none text-center">#</div>
      <div>
        <span class="w-[100px] cursor-pointer select-none overflow-ellipsis" (click)="onTransactionSortChange('name')">
          Name
          <i class="{{ getSortIconClass('name') }} text-grey-light text-xl"></i>
        </span>
      </div>
      <div>
        <span class="w-[100px] cursor-pointer select-none overflow-ellipsis" (click)="onTransactionSortChange('tokenPriceUSD')">
          Price
          <i class="{{ getSortIconClass('tokenPriceUSD') }} text-grey-light text-xl"></i>
        </span>
      </div>
      <div class="flex items-baseline">
        <div
          class="max-w-[100px] cursor-pointer select-none overflow-hidden overflow-ellipsis whitespace-nowrap"
          (click)="onTransactionSortChange('priceChange')"
        >
          Change 24h
        </div>
        <i class="{{ getSortIconClass('priceChange') }} text-grey-light text-xl ml-1"></i>
      </div>
      <div class="flex items-baseline">
        <div
          class="max-w-[100px] cursor-pointer select-none overflow-hidden overflow-ellipsis whitespace-nowrap"
          (click)="onTransactionSortChange('volume24h')"
        >
          Volume 24h
        </div>
        <i class="{{ getSortIconClass('volume24h') }} text-grey-light text-xl ml-1"></i>
      </div>
      <div>
        <span class="w-[100px] cursor-pointer select-none overflow-ellipsis" (click)="onTransactionSortChange('marketCap')">
          Market cap
          <i class="{{ getSortIconClass('marketCap') }} text-grey-light text-xl"></i>
        </span>
      </div>
      <div></div>
    </div>

    <rx-virtual-scroll-viewport class="u-hide-scrollbar min-h-[500px]" [itemSize]="47" #transactionsEl #scrollviewPort>
      <div class="c-table__body u-hide-scrollbar">
        <div class="c-table-row c-table-row--tokens" *rxVirtualFor="let token of chainTokens(); trackBy: 'id'; let i = index">
          <div class="mr-[5px] flex-none text-center text-dirty-white">{{ i + 1 }}</div>

          <div class="flex cursor-pointer items-center" (click)="openTokenPreview(token.address)">
            <cmp-pair-logo class="mr-[15px]" [url]="token.logoURI" [name]="token.symbol"></cmp-pair-logo>
            <div class="flex flex-col items-start gap-[2px] text-left">
              <span class="text-[16px] font-semibold text-white max-mobile-msmall:text-[14px]">{{ token.name }}</span>
              <span class="text-[12px] font-light text-dirty-white">{{ token.symbol }}</span>
            </div>
            <!-- 
            <div>
              <span class="text-[16px] font-semibold text-white">{{ token.name }}</span>
              <span class="ml-[5px] font-light text-dirty-white">{{ token.symbol }}</span>
            </div> -->
          </div>

          <div class="{{ token?.priceChange < 0 ? 'text-danger' : 'text-success' }}">${{ token.tokenPriceUSD | format }}</div>
          <div class="{{ token?.priceChange < 0 ? 'text-danger' : 'text-success' }}">
            {{ token?.priceChange > 0 ? '+' : '' }}{{ token?.priceChange | format: { decimals: 2 } }}%
          </div>
          <div class="flex items-center">${{ token?.data24h?.volume24hData?.total | format }}</div>
          <div>${{ token.marketCap | format }}</div>
        </div>
      </div>
    </rx-virtual-scroll-viewport>
  </div>
</section>
